var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNextBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.25,
    fill: "white",
    stroke: "#151319",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 30L22 36V24L30.5 30ZM31 36L39.5 30L31 24V36ZM27.03 30L24 27.86V32.14L27.03 30ZM36.03 30L33 27.86V32.14L36.03 30Z",
    fill: "#151319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNextBtn);
export default __webpack_public_path__ + "static/media/ic_next_btn.d9e92b73193449a6f8ffda040524e18c.svg";
export { ForwardRef as ReactComponent };